/**
 * ...
 * @author Fred Pinn
 */
/**
 * package: com.inq.ui
 * class: Html
 * @extends com.inq.ui.Container
 * @constructor
 * @param {string} tagName
 * @param {string} _id
 * @param {HTMLElement} parentNode
 */
com.inq.ui.Html = function(tagName,_id,parentNode) {
	//Define the tagName to be used (format is conditional)
	tagName = this.defineTagName(tagName);

	//We need to init com.inq.ui.Container with element _id
	//_id can exist or NOT exist in the dom and may need to be created (hence no id will be in the dom).
	//To avoid this save a reference and use it in the overridden determineExistingElement method

	this._div = com.inq.ui.Container.getElementById(_id) || parentNode.document.createElement(tagName);
	com.inq.ui.Container.call(this, _id, null, parentNode.document);
	com.inq.ui.ClientBody.registerElement(this);
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.Html, "com.inq.ui.Html");

/**
 * Public override function to properly use our target element and NOT id!
 *
 * @override
 * @param {string} _id
 * @return {HTMLElement}
 */
com.inq.ui.Html.prototype.determineExistingElement = function(_id){
	return this._div;
};

/**
 * defineTagName: defines the tagName to be used (format is conditional)
 *
 * @this com.inq.ui.Html
 * @param {string} tag
 * @return {string}
 */
com.inq.ui.Html.prototype.defineTagName = function(tag){
	return tag.toUpperCase().split(":")[1] || tag;
};

/**
 * buildStyle
 *
 * override 	private function _buildStyle():Void
 * @override
 * @private
 * @this com.inq.ui.Html
 * @return {void}
 */
com.inq.ui.Html.prototype.buildStyle = function () {
	if (this._div.id == com.inq.ui.Container.SC_TITLEBAR || this._div.id == com.inq.ui.Container.SC_RESIZE) {
		this.buildNewStyle();
	}else
    	this.buildClientElementStyle();
};


/**
 * Set style.visible property on this (HTML DOM object) and update styles and _visible property.
 * TODO: the given validation is wrong because any string except "false" will make isVisible true.
 *
 * @override
 * @private
 * @this  com.inq.ui.Html
 * @param {boolean}  val - true/false, it will accept a boolean true or false or a string "true" or "false"
 */
com.inq.ui.Html.prototype.setVisible = function (val) {
	try {
		var isVisible = !("false" == val || null == val || false == val);
		this._div.style.display = isVisible ? "" : "none";
		this.styles.visible = isVisible ? "true" : "false";
		this._visible = isVisible;
		if (this._visible) {
			this.fireVisible();
		} else {
			this.fireHidden();
		}
	} catch (e) {
		/* swallow any exception and continue */
	}
};


/**
 * setID - set the identifier for the container
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * override public function setID(val:String):Void
 * @override
 * @public
 * @this com.inq.ui.Html
 * @param {string}  val
 * @return {void}
 */
com.inq.ui.Html.prototype.setID = function(val) {
	    var alreadyPrepended = val.indexOf("tcChat_") == 0 || val.indexOf("inq") == 0;
	    var safeID = "tcChat_" + val;
	    if (!alreadyPrepended)
	        this._div.id = safeID;
	    this.styles["id"] = val;// getMxmlItem uses the original id stored in styles ... so we dont prepend here
	com.inq.ui.ClientBody.registerElement(this);
};


/**
 * applyStyles
 *
 * $type TFun([],TEnum(Void,[]))
 * public function applyStyles():Void
 * @public
 * @this com.inq.ui.Html
 * @return {void}
 */
com.inq.ui.Html.prototype.applyStyles = function() {
	com.inq.ui.Container.prototype.applyStyle.call(this);
};


/**
 * _getText
 *
 * $type TFun([],TInst(String,[]))
 * public function _getText():String
 * @public
 * @this com.inq.ui.Html
 * @return {string}
 */
com.inq.ui.Html.prototype._getText = function() {
	return this._div.innerHTML;
};


/**
 * _setText
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public function _setText(text:String):String
 * @public
 * @this com.inq.ui.Html
 * @param {string}  text
 * @return {string}
 */
com.inq.ui.Html.prototype._setText = function(text) {
	this._div.innerHTML = text;
	return text;
};


/**
 * _setStyle
 *
 * $type TFun([{ name => style, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private function _setStyle(style:String):String
 * @private
 * @this com.inq.ui.Html
 * @param {string}  style
 * @return {string}
 */
com.inq.ui.Html.prototype._setStyle = function(style) {
	this._style = style;
	return this._style;
};


/**
 * removeFromBody
 *
 * $type TFun([],TEnum(Void,[]))
 * public function removeFromBody()
 * @public
 * @this com.inq.ui.Html
 * @return {void}
 */
com.inq.ui.Html.prototype.removeFromBody = function() {
	/** @type {Node} */
	var p = this._div.parentNode;
	if(p != null) p.removeChild(this._div);
};

/** @type {string} */
com.inq.ui.Html.prototype.text = null;
/** @type {string} */
com.inq.ui.Html.prototype.style = null;
/** @type {com.inq.ui.Html} */
com.inq.ui.Html.prototype.__class__ = com.inq.ui.Html;
